"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_1 = require("react-router");
const qs_1 = require("qs");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const CampaignTypeSelector_1 = require("./CampaignTypeSelector");
const NewCampaignPopover_1 = require("./NewCampaignPopover");
const GridIconPopover_1 = require("./GridIconPopover");
const UserIconPopover_1 = require("./UserIconPopover");
class NavBar extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isSearchFocused: false,
            keyword: qs_1.parse(window.location.search.slice(1)).keyword || '',
        };
        this.setState = this.setState.bind(this);
    }
    renderLeftContent() {
        const { media } = this.props;
        if (media === 'Desktop') {
            return React.createElement("div", { style: { width: 56 } });
        }
        return React.createElement(UserIconPopover_1.default, { device: media });
    }
    isRunningInIframe() {
        return window !== window.parent;
    }
    renderRightContent() {
        const { media, onCreate } = this.props;
        switch (media) {
            case 'Desktop':
                return (React.createElement("div", { style: {
                        width: 56,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    } },
                    React.createElement(GridIconPopover_1.default, { device: media }),
                    React.createElement(UserIconPopover_1.default, { device: media })));
            case 'Tablet':
                return React.createElement(NewCampaignPopover_1.default, { onCreate: onCreate, media: media });
            case 'Mobile':
            default:
                return React.createElement("div", { style: { width: 24 } });
        }
    }
    renderSegmentControl() {
        const { location, media } = this.props;
        const selectedControl = qs_1.parse(location.search.substring(1)).campaignStatus || 'all';
        const segmentControlButtonStyle = Object.assign(Object.assign(Object.assign({}, src_1.text), { width: 98, height: 20, textAlign: 'center', paddingTop: media === 'Desktop' ? 2 : 1, flex: '1 1 auto', fontSize: media === 'Desktop' ? 15 : 17 }), src_1.semibold);
        return (React.createElement(src_1.SegmentControl, { style: {
                flex: 'none',
                width: media === 'Mobile' ? '100%' : 288,
            } },
            React.createElement("div", { style: Object.assign(Object.assign({}, segmentControlButtonStyle), { color: selectedControl === 'all' ? 'white' : src_1.turquoise, backgroundColor: selectedControl === 'all' ? src_1.turquoise : 'white' }), onClick: () => this.setListStatus('all') }, "All"),
            React.createElement("div", { style: Object.assign(Object.assign({}, segmentControlButtonStyle), { color: selectedControl === 'drafts' ? 'white' : src_1.turquoise, backgroundColor: selectedControl === 'drafts' ? src_1.turquoise : 'white', borderLeft: `2px solid ${src_1.turquoise}`, borderRight: `2px solid ${src_1.turquoise}` }), onClick: () => this.setListStatus('drafts') }, "Drafts"),
            React.createElement("div", { style: Object.assign(Object.assign({}, segmentControlButtonStyle), { color: selectedControl === 'published' ? 'white' : src_1.turquoise, backgroundColor: selectedControl === 'published' ? src_1.turquoise : 'white' }), onClick: () => this.setListStatus('published') }, "Published")));
    }
    setListStatus(nextStatus) {
        const { history, location } = this.props;
        const newQuery = qs_1.stringify(Object.assign(Object.assign({}, qs_1.parse(location.search.substring(1))), { campaignStatus: nextStatus }));
        history.replace(`/campaigns/?${newQuery}`);
    }
    render() {
        const { media, onCreate, setKeyword } = this.props;
        const { isSearchFocused, keyword } = this.state;
        const baseStyle = {
            width: '100%',
            backgroundColor: src_1.almostWhite,
            borderBottom: `1px solid ${src_1.titanium}`,
            flex: 'none',
        };
        const getTextStyle = () => {
            if (isSearchFocused) {
                return {
                    width: media === 'Mobile' ? 280 : 256,
                    height: 24,
                    lineHeight: '24px',
                    display: 'flex',
                    alignItems: 'center',
                };
            }
            return {
                width: media === 'Mobile' ? 280 : 256,
                height: 24,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            };
        };
        return (React.createElement("div", { style: Object.assign({ height: media === 'Desktop' ? 97 : 139 }, baseStyle) },
            React.createElement("div", { style: {
                    height: 40,
                    display: 'flex',
                    justifyContent: this.isRunningInIframe() ? 'center' : 'space-between',
                    alignItems: this.isRunningInIframe() ? 'center' : 'flex-end',
                    paddingLeft: media === 'Mobile' ? 24 : 32,
                    paddingRight: media === 'Mobile' ? 24 : 32,
                    marginBottom: media === 'Desktop' ? 0 : 16,
                } },
                !this.isRunningInIframe() && this.renderLeftContent(),
                React.createElement(CampaignTypeSelector_1.default, { media: media }),
                !this.isRunningInIframe() && this.renderRightContent()),
            React.createElement("div", { style: {
                    height: media === 'Desktop' ? 57 : 83,
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: media === 'Desktop' ? 'row' : 'column',
                    alignItems: 'center',
                    paddingLeft: media === 'Mobile' ? 24 : 32,
                    paddingRight: media === 'Mobile' ? 24 : 32,
                } },
                media === 'Desktop' && (React.createElement("div", { style: { width: 288 } },
                    React.createElement("div", { style: { width: 140 } },
                        React.createElement(NewCampaignPopover_1.default, { onCreate: onCreate, media: media })))),
                this.renderSegmentControl(),
                React.createElement("div", { style: {
                        width: media === 'Mobile' ? '100%' : 288,
                        height: 28,
                        backgroundColor: src_1.cloud,
                        borderRadius: 4,
                        marginTop: 14,
                        marginBottom: 14,
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }, onClick: () => this.setState({
                        isSearchFocused: true,
                    }) },
                    React.createElement("div", { style: {
                            height: 16,
                            width: 16,
                            margin: '0 8px',
                        } },
                        React.createElement(src_1.SearchIcon, { fill: src_1.silver, height: "16", width: "16", viewBox: "0 0 24 24" })),
                    React.createElement(src_1.Text, { id: "list-page-search", text: keyword, size: "medium", contentEditable: isSearchFocused, handleChange: (searchString) => {
                            this.setState({
                                isSearchFocused: false,
                                keyword: searchString,
                            });
                            setKeyword(searchString);
                        }, onBlurChange: true, placeholder: true, placeholderText: "Search", textStyle: getTextStyle() })))));
    }
}
exports.default = react_router_1.withRouter(NavBar);
